import { ChevronRight, Home } from 'lucide-react'
import { Link, useLocation } from 'react-router-dom'

import { useT } from '@/lib/i18n/AdminI18nProvider'

function labelForSegment(
  segment: string,
  index: number,
  total: number,
  t: (key: string) => string,
): string {
  const key = `crumbs.${segment}`
  const translated = t(key)
  if (translated !== key) return translated
  if (/^\d+$/.test(segment)) {
    return total > 1 && index === total - 1 ? t('crumbs.detail') : segment
  }
  return segment
}

export function AdminBreadcrumbs() {
  const t = useT()
  const { pathname } = useLocation()
  const raw = pathname.replace(/^\//, '').split('/').filter(Boolean)
  const homeLabel = t('crumbs.dashboard')

  const crumbs: { to: string; label: string }[] = [{ to: '/', label: homeLabel }]

  if (raw.length === 0) {
    return (
      <nav className="flex flex-wrap items-center gap-1 text-xs text-muted-foreground" aria-label={t('common.pagePosition')}>
        <span className="inline-flex items-center gap-1 font-medium text-foreground">
          <Home className="h-3.5 w-3.5 shrink-0 text-mainColor" />
          {homeLabel}
        </span>
      </nav>
    )
  }

  let acc = ''
  raw.forEach((segment, i) => {
    acc += `/${segment}`
    crumbs.push({
      to: acc,
      label: labelForSegment(segment, i, raw.length, t),
    })
  })

  return (
    <nav className="flex flex-wrap items-center gap-1 text-xs text-muted-foreground" aria-label={t('common.pagePosition')}>
      {crumbs.map((c, i) => (
        <span key={c.to} className="inline-flex items-center gap-1">
          {i > 0 ? (
            <ChevronRight className="h-3.5 w-3.5 shrink-0 opacity-50" />
          ) : null}
          {i === crumbs.length - 1 ? (
            <span className="font-medium text-foreground">{c.label}</span>
          ) : (
            <Link to={c.to} className="rounded px-1 py-0.5 transition-colors hover:bg-muted hover:text-foreground">
              {i === 0 ? (
                <span className="inline-flex items-center gap-1">
                  <Home className="h-3.5 w-3.5 shrink-0 text-mainColor" />
                  {c.label}
                </span>
              ) : (
                c.label
              )}
            </Link>
          )}
        </span>
      ))}
    </nav>
  )
}
